import { render, staticRenderFns } from "./meituanConsumeSettingNew.vue?vue&type=template&id=027d77ce&scoped=true"
import script from "./meituanConsumeSettingNew.vue?vue&type=script&lang=js"
export * from "./meituanConsumeSettingNew.vue?vue&type=script&lang=js"
import style0 from "./meituanConsumeSettingNew.vue?vue&type=style&index=0&id=027d77ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027d77ce",
  null
  
)

export default component.exports